module.exports = __webpack_public_path__ + "static/media/full_break.03a1f3b0.svg";